/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useEffect, useState, useContext, useCallback } from 'react';

import { Column, Heading, Row, UserContext } from 'school-space-client/components';
import { getCustomerBookings } from 'school-space-client/api';
import { useBankHolidays } from 'school-space-client/hooks';
import { getTodaysDate } from 'school-space-utils/date';

import BookingCard from '../components/cards/BookingCard';

const css = {
    cards: theme => ({
        marginTop: theme.layout.baseline * 2
    })
};

const Bookings = () => {
    const [bookings, setBookings] = useState([]);
    const { id: userId } = useContext(UserContext);

    const bankHolidays = useBankHolidays();
    const holidays = bankHolidays.map(holiday => holiday.date);

    const fetchBookings = useCallback(
        () =>
            getCustomerBookings(userId, {
                fromDate: getTodaysDate(),
                states: ['confirmed', 'amending', 'cancelled']
            })
                .then(data => {
                    if (data.length > 0) {
                        setBookings(data);
                    } else {
                        setBookings(null);
                    }
                })
                .catch(error =>
                    setBookings(() => {
                        throw error;
                    })
                ),
        [userId]
    );

    useEffect(() => {
        fetchBookings();
    }, [fetchBookings]);

    return (
        <main>
            <Row>
                <Column s={[6]} m={[12]} l={[12]}>
                    <Heading level="1" size="x-large">
                        Upcoming bookings
                    </Heading>
                </Column>
            </Row>
            <div css={css.cards}>
                {bookings ? (
                    bookings.map((booking, index) => (
                        <BookingCard
                            key={booking.id}
                            booking={booking}
                            onUpdate={fetchBookings}
                            isExpanded={index === 0}
                            holidays={holidays}
                        />
                    ))
                ) : (
                    <p>You have no upcoming bookings</p>
                )}
            </div>
        </main>
    );
};

export default Bookings;
